// Helper functions to prevent XSS attacks by validating URLs before using them

// Check if a redirect URL is safe - we only want to redirect users within our own site
export const isValidRedirectUrl = (url) => {
    if (!url || typeof url !== 'string') {
        return false;
    }

    try {
        // Relative URLs like "/dashboard" are always safe
        if (url.startsWith('/')) {
            return true;
        }

        // For absolute URLs, make sure they point to our own domain
        const parsedUrl = new URL(url, window.location.origin);

        // Reject if it's trying to redirect to a different website
        return parsedUrl.origin === window.location.origin;
    } catch {
        // URL parsing failed, so it's not valid
        return false;
    }
};

// Check if an image URL is safe - we allow standard web images, data URLs, and blob URLs
export const isValidImageUrl = (url) => {
    if (!url || typeof url !== 'string') {
        return false;
    }

    try {
        const parsedUrl = new URL(url);
        // Allow normal web images, inline data images, and blob URLs (for uploaded files), but block dangerous stuff like javascript:
        return ['https:', 'http:', 'data:', 'blob:'].includes(parsedUrl.protocol);
    } catch {
        // Malformed URL, not safe
        return false;
    }
};

// Check if an external link is safe - only allow normal web links
export const isValidExternalUrl = (url) => {
    if (!url || typeof url !== 'string') {
        return false;
    }

    try {
        const parsedUrl = new URL(url);
        // Only allow regular web links, no javascript: or file: protocols
        return ['https:', 'http:'].includes(parsedUrl.protocol);
    } catch {
        // Bad URL format
        return false;
    }
};

// Wrapper functions that return a safe URL or a fallback if something looks suspicious

export const getSafeRedirectUrl = (url, fallback = '/') => {
    return isValidRedirectUrl(url) ? url : fallback;
};

export const getSafeImageUrl = (url, fallback = null) => {
    return isValidImageUrl(url) ? url : fallback;
};

export const getSafeExternalUrl = (url, fallback = '#') => {
    return isValidExternalUrl(url) ? url : fallback;
};